(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('ResetPasswordController', ResetPasswordController);

    ResetPasswordController.$inject = ['$window', '$stateParams', 'common', 'dataservice'];
    /* @ngInject */
    function ResetPasswordController($window, $stateParams, common, dataservice) {
        var vm = this;
        vm.title = 'Reset Password';
        vm.password = "";
        vm.confirmPassword = "";
        vm.passwordResetError = "";
        vm.passwordResetSuccessfully = false;
        vm.resetPassword = resetPassword;
        vm.loadErrorMsg = "";
        vm.loading = true;
        vm.passwordPattern = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{12,}$/;

        activate();

        function activate() {

            var promises = [getResetItem()];
            return common.$q.all(promises).then(function (data) {
                vm.loading = false;
            }, function (error) { });
        }

        function getResetItem() {
            dataservice.getItem('api/Account/GetPasswordReset/' + $stateParams.uid).then(function (response) {
                var data = response.data;
                if (data.Success === false) {
                    vm.loadErrorMsg = data.Message;
                }
            }, function (error) { });

        }

        function resetPassword() {
            if (!vm.Password) {
                common.logger.error("Please supply a password");
                return;
            }

            var dto = {
                UId: $stateParams.uid,
                password: vm.Password
            }
            dataservice.saveItem('api/Account/ResetPassword', dto, true).then(function (response) {
                if (response.data.Success) {
                    vm.passwordResetSuccessfully = true;
                }
                else {
                    vm.passwordResetError = true;
                }
            }, function (error) { });
        }
    }
})();
